import Vue from "vue"
import Vuex from "vuex"
import getters from "./getters"
import app from "./modules/app"
import setting from "./modules/setting"
import tagsView from "./modules/tags-view"
import user from "./modules/user"
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    setting,
    tagsView
  },
  getters
})

export default store
